import Lottie from "lottie-react";
import loadingAnimation from "../loading.json";

const Loading = () => {

  return (
    <div className="loader">
      <Lottie 
          animationData={loadingAnimation} 
          loop={true}
      />
    </div>
  );
};

export default Loading;